import styled from "styled-components"

import { AccordionPanel } from "components/atoms/Accordion"
import devices from "styles/devices"

export const Root = styled.div`
  width: 100%;
`

export const Header = styled.h1`
  font-size: 32px;
  font-weight: 550;
  margin: 1.5em 0 0 0.625em;
  @media screen and ${devices.bp_lg} {
    margin-top: 3em;
  }
`

export const SubHeader = styled.p`
  line-height: 1.5em;
  margin: 1.5em 1.25em;
  & button {
    font-weight: 550;
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }
  @media screen and ${devices.bp_lg} {
    width: 34em;
  }
`

export const ReassuranceBanner = styled.div`
  margin: 0 1.25em 6em;
  & > div {
    background: ${(props) => props.theme.secondaryOne};
    padding: 1em;
    display: flex;
    align-items: center;
    border-radius: 8px;
  }
  @media screen and ${devices.bp_lg} {
    width: 34em;
  }
`

export const ShieldContainer = styled.div`
  & svg {
    margin-right: 1em;
    & > path {
      fill: ${(props) => props.theme.primaryOne};
    }
  }
`

export const ReassuranceBannerTextContainer = styled.div`
  & p {
    margin: 0;
  }
  & strong {
    font-weight: 550;
  }
`

export const FileIconWrapper = styled.div`
  margin: auto 1rem auto 0;
`

export const FlexRow = styled.div`
  display: flex;
`

export const FlexRowCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media screen and ${devices.bp_lg} {
    flex-direction: row;
  }
`

export const MortgageDocumentsFailedContainer = styled.div`
  text-align: center;
`

export const InfoContainer = styled.div`
  display: inline-flex;
  font-weight: 600;
`

export const InfoWrapper = styled.div`
  margin: auto 0.5rem;
`

export const Wrapper = styled.div`
  padding: 1em 2em;
  border-radius: 1em;
  margin-top: 1em;
`

export const AccordionWrapper = styled(Wrapper)`
  background: #d1ddfc;
`

export const AccordionContainer = styled.div`
  background: #fff;
  margin: auto;
  border-radius: 16px;
  padding: 1rem;
  & h3 {
    margin: 2rem;
    font-weight: 550;
    font-size: 26px;
    line-height: 34px;
  }
  & h4 {
    margin: 1rem 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 34px;
  }
  // override the accordion styles
  & .name {
    font-size: 16px;
    font-weight: 600;
  }
  @media screen and ${devices.bp_lg} {
    width: 64em;
    margin-bottom: 4.5em;
    & .name {
      font-weight: 600;
    }
  }
  @media screen and ${devices.bp_xs} {
    margin-bottom: 32px;
  }
`

export const AccordionContent = styled.div`
  margin: 1em 0;
  line-height: 1.5em;
  @media screen and ${devices.bp_lg} {
    display: flex;
  }
`

export const AccordionContentInfo = styled.div`
  & h4 {
    font-weight: 550;
    font-size: 16px;
    margin: 1.5em 0;
  }
  & > ul {
    padding-inline-start: 0;
    margin: 0;
    & li {
      list-style-type: none;
      margin-bottom: 1.25em;
      & strong {
        font-weight: 550;
      }
      & .tick {
        margin-right: 0.875em;
      }
    }
  }
  @media screen and ${devices.bp_lg} {
    flex: 1;
    margin-right: 3.375em;
  }
`

export const UploadBoxContainer = styled.div`
  @media screen and ${devices.bp_lg} {
    flex: 1;
  }
`

export const OtherDocuments = styled.div`
  & p {
    margin: 0 0 1em 0;
  }
  & ul {
    padding-inline-start: 1em;
    & li::marker {
      font-size: 0.75em;
    }
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  @media screen and ${devices.bp_lg} {
    width: 34em;
  }
`

export const FaqContainer = styled.div`
  margin: auto;
  h3 {
    font-weight: 700;
    display: inline-block;
    font-size: 22px;
    padding-bottom: 0.2em;
    border-bottom: 4px solid blue;
    margin-bottom: 1.4em;
  }
  ${AccordionPanel} {
    border-bottom: 1px solid ${(props) => props.theme.shade60};
  }
  @media screen and ${devices.bp_lg} {
    width: 64em;
    margin-bottom: 2em;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  margin: auto;
  @media screen and ${devices.bp_lg} {
    width: 65em;
  }
  @media screen and ${devices.bp_xl} {
    width: unset;
  }
  @media screen and (min-width: 1360px) {
    width: 65em;
  }
`

export const HeaderContentLHS = styled.div`
  flex: 1;
`
export const HeaderContentRHS = styled.div`
  @media screen and ${devices.bp_xl} {
    margin-right: 8em;
  }
  @media screen and (min-width: 1360px) {
    margin-right: 0;
  }
`

export const QRCodeContainer = styled.div`
  display: none;
  padding: 1.5em;
  background: #fff;
  border-radius: 8px;
  margin-top: 5.25em;
  p {
    line-height: 18px;
    font-size: 12px;
    width: 10.7em;
    margin: 1.3em 0 0 0;
  }
  @media screen and ${devices.bp_lg} {
    display: inline-block;
  }
`

export const OfferDocumentsContainer = styled.div``

export const OfferDocumentsHeader = styled.div`
  display: flex;
`

export const OfferDocumentsTitle = styled.h4``

export const OfferDocumentsDescription = styled.div`
  p {
    color: #3b4258;
    margin: 0 0 24px 0;
  }
`

export const OfferDocumentItem = styled.div<{ isNotLast?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  ${(props) => props.isNotLast && "border-bottom: 1px solid #A1AAC7;"}

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 0;
    gap: 0;
  }
`

export const OfferDocumentDetails = styled.div`
  margin: 24px 0 0 0;
  flex: 1;
  min-width: 0;

  a {
    word-break: break-word;
    overflow-wrap: break-word;
  }

  div {
    margin: 1rem 0;
  }

  @media screen and (max-width: 767px) {
    margin: 16px 0 0 0;
  }
`

export const OfferDocumentDownload = styled.div`
  margin: auto 0 auto auto;
  flex-shrink: 0;

  span {
    margin-left: 0.5rem;
  }

  @media screen and (max-width: 767px) {
    margin: 0;
    align-self: flex-start;
  }
`
export const OfferDocumentDate = styled.div`
  color: #3b4258;

  @media screen and (max-width: 767px) {
    margin: 16px 0 24px 0;
  }
`
